import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { IconButton, FilterButton } from '../../../../components/buttons';
import ModalFormOrder from '../ModalFormOrder';
import ModalFilter from './ModalFilter';
import Download from '../../../../components/exports/excel/custom'

export default function (props) {
    const [ testData, setTestData ] = useState(localStorage.getItem('biteship_test_data')||'notActive') 
    const [ modalFilter, setModalFilter ] = useState(false);
    const [ modalOrder, setModalOrder ] = useState(false);

    const onClickOrderSection = () => {
        if (testData == 'active') {
          alert("Mohon matikan mode testing untuk melakukan pengiriman");
          return
        }   
        if (!props.user.phone ) {
          alert("Mohon masukkan nomor telepon terlebih dahulu di bagian Pengaturan");
          return
        }
        if (!props.user.organizationName) {
          alert("Mohon masukkan nama perusahaan terlebih dahulu di bagian Pengaturan");
          return
        }
        if (modalOrder){
            setModalOrder(false);
        } else {
            setModalOrder(true);
        }
      };

    return (
        <Row className="p-4">
            <Col>
                <h5>Halaman Utama</h5>
            </Col>
            <Col className="text-right">
                
                {
                    props.data.length > 0 ?
                    <Download.Orders 
                        filename={`Shipment Details`}
                        data={props.data}
                        title={"Shipment"}
                    /> :
                    <IconButton 
                        onClick={props.onClickDownload}  
                        className="btn-secondary border"
                        iconClassName="fas fa-file-download"
                        loading={props.loadingDownload}
                    >
                        Export
                    </IconButton> 
                }
          
                <FilterButton onClick={() => setModalFilter(true)} className="btn-secondary border" iconClassName="fas fa-filter">
                    {props.filterTitle ? `Filter | ${props.filterTitle}` : "Filter"}
                </FilterButton>
                <IconButton onClick={onClickOrderSection} iconClassName="fas fa-paper-plane">
                    Kirim Barang
                </IconButton>
            </Col>
            <ModalFormOrder
                show={modalOrder}
                onHide={() => setModalOrder(false)}
                admin={false}
                userId={props.userId}
            />
            <ModalFilter
                userId={props.userId}
                show={modalFilter}
                onHide={() => setModalFilter(false)}
                onPreviewFilter={props.onPreviewFilter}
                onSubmitFilters={props.onSubmitFilters}
            />
        </Row>
    )
}